import React from 'react';

const FacebookLogo: React.FC = () => {
  return (
    <svg
      width="35px"
      height="33px"
      viewBox="0 0 35 33"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="FacebookLogo"
    >
      <title id="FacebookLogo">Facebook</title>
      <rect fill="#485992" x="0" y="0" width="34.6923077" height="33" rx="3" />
      <path
        d="M24.0760824,14.030445 L24.0760824,11.9227166 C24.0760824,10.8688525 24.8027883,10.6932084 25.1661412,10.6932084 C25.7111707,10.6932084 28.4363178,10.6932084 28.4363178,10.6932084 L28.4363178,5.95081967 L24.0760824,5.95081967 C19.1708176,5.95081967 18.0807587,9.46370023 18.0807587,11.5714286 L18.0807587,14.030445 L15.3556116,14.030445 L15.3556116,17.3676815 L15.3556116,19.4754098 L18.2624352,19.4754098 C18.2624352,25.6229508 18.2624352,33 18.2624352,33 L23.7127294,33 C23.7127294,33 23.7127294,25.6229508 23.7127294,19.4754098 L27.8912884,19.4754098 L28.0729648,17.3676815 L28.4363178,14.030445 L24.0760824,14.030445 Z"
        fill="#FEFEFE"
      />
    </svg>
  );
};

export default FacebookLogo;
